export default {
  all (state) {
    return state.all
  },
  current (state) {
    return state.current
  }
}
